import { PayIdType as PAY_ID_TYPE_VALUES, type PayIdType } from '@shared/prisma/enums';
import type { Decimal } from 'decimal.js';

export const PAYMENT_ACCOUNT_ENTITIES = {
    SUPPLIER: 'SUPPLIER',
    POLICY_HOLDER: 'POLICY_HOLDER',
    OTHER_CONTACT: 'OTHER_CONTACT',
} as const;

export type PaymentAccountEntity = keyof typeof PAYMENT_ACCOUNT_ENTITIES;

export { PAY_ID_TYPE_VALUES as PAY_ID_TYPES };

export const accountBsbRegex = /^\d{6}$/;

export const abnRegex = /^\d{11}$/;

export type BasePaymentAccount = {
    payIdType: PayIdType | null;
    payIdValue: string | null;
    accountName: string | null;
    accountBsb: string | null;
    accountNo: string | null;
    isRegisteredForGst: boolean | null;
    abn: string | null;
};

export type PolicyHolderPaymentAccount = BasePaymentAccount & {
    entity: Extract<PaymentAccountEntity, 'POLICY_HOLDER'>;
    // Typed as `string` (not `Decimal`) to keep the legacy public-claim-submission
    // payload shape working — that flow carries the value as a serialised string and
    // narrowing it here would break the existing call sites. Sibling variants use `Decimal`.
    inputTaxCreditEntitlement: string;
};

export type OtherContactPaymentAccount = BasePaymentAccount & {
    entity: Extract<PaymentAccountEntity, 'OTHER_CONTACT'>;
    inputTaxCreditEntitlement: Decimal;
};

export type SupplierPaymentAccount = BasePaymentAccount & {
    entity: Extract<PaymentAccountEntity, 'SUPPLIER'>;
    remittanceEmail: string | null;
};

export type PaymentAccount = PolicyHolderPaymentAccount | OtherContactPaymentAccount | SupplierPaymentAccount;
